import { render, staticRenderFns } from "./ExportTabButton.vue?vue&type=template&id=27f68feb&"
import script from "./ExportTabButton.vue?vue&type=script&lang=js&"
export * from "./ExportTabButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f68feb')) {
      api.createRecord('27f68feb', component.options)
    } else {
      api.reload('27f68feb', component.options)
    }
    module.hot.accept("./ExportTabButton.vue?vue&type=template&id=27f68feb&", function () {
      api.rerender('27f68feb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Statistics/TouchpointInfo/ExportTabButton.vue"
export default component.exports